import UnscheduledReader from "../../../components/candidate-sub-components/UnscheduledReader";

export default function UnscheduledReaderPage() {
  return (
    <div className="w-full h-full bg-gray-50 ">
      <UnscheduledReader />
    </div>
  );
}
